import {DataService} from '@/config/dataService/dataService';
import {notification} from 'ant-design-vue';

const lists = {
    Supplier: ['suppliers', '/suppliers'],
    Sender: ['senders', '/senders'],
    Team: ['teams', '/teams'],
    Role: ['roles', '/roles'],
    Script: ['scripts', '/scripts'],
    Question: ['questions', '/flowquestions'],
};
const actions = {};
Object.entries(lists).forEach(([name, [key, path]]) => {
    const requests = new WeakMap();
    actions[`get${name}Options`] = async ({state, commit}, query = {}) => {
        const token = {};
        requests.set(state, token);
        commit('listOptionsBegin', key);
        try {
            const items = await DataService.getAll(path, query);
            if (requests.get(state) === token) commit('listOptionsSuccess', {key, items});
        } catch (error) {
            if (requests.get(state) !== token) return;
            commit('listOptionsError', {key, error});
            notification.error({message: 'De keuzelijst kon niet volledig worden geladen. Probeer het opnieuw.'});
        }
    };
});

export default {
    state: () => ({
        suppliers: [], senders: [], teams: [], roles: [], scripts: [], questions: [],
        loading: {}, errors: {},
    }),
    actions,
    mutations: {
        listOptionsBegin(state, key) {
            state.loading[key] = true;
            state.errors[key] = null;
        },
        listOptionsSuccess(state, {key, items}) {
            state[key] = items;
            state.loading[key] = false;
        },
        listOptionsError(state, {key, error}) {
            state.loading[key] = false;
            state.errors[key] = error;
        },
        addSupplierOption(state, supplier) {
            if (!state.suppliers.some(item => item.id === supplier.id)) state.suppliers.push(supplier);
        },
    },
};
